import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationElement, ListConfigurationStates } from './../models/configuration.model';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';

const API_URL = environment.API_URL


@Injectable({
  providedIn: 'root'
})

export class ConfigurationService {

  lstStates: ListConfigurationStates[] = [];

  constructor(private http: HttpClient) { }

  getConfigurationById(device_id: number, company_id: number): Observable<ConfigurationElement> {
    const API_URL_DEV = `${API_URL}/companies/${company_id}/devices/${device_id}/config`;
    return this.http.get<ConfigurationElement>(`${API_URL_DEV}`);
  }

  updateConfiguration(device_id: number, configuration: ConfigurationElement, company_id: number): Observable<any> {
    const API_URL_DEV = `${API_URL}/companies/${company_id}/devices/${device_id}/config`;
    return this.http.put<ConfigurationElement[]>(`${API_URL_DEV}`, configuration);
  }

  getConfigurationStatesList(): ListConfigurationStates[] {
    this.lstStates=[];

    this.lstStates = this.getAllStatesList().filter(
      s => s.value != 1
    );
    return this.lstStates;
  }

  getAllStatesList(): ListConfigurationStates[] {
    this.lstStates=[];

    this.lstStates = [
      {value: 0, viewValue: 'Hibernado'},
      {value: 1, viewValue: 'Alarma'},
      {value: 2, viewValue: 'Activo'},
      {value: 4, viewValue: 'Preactivo'},
    ];
    return this.lstStates;
  }

}
